import { React, useCallback, useState } from "react";
import Logo from "../img/logo.svg";
import { AiFillInstagram, AiFillTwitterCircle } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";

import { MobileMenu } from "../components";

const Header = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const [active, setActive] = useState(false);

  const handleClick = useCallback(() => {
    setActive(false);
  }, []);

  return (
    <header className="bg-black lg:backdrop-filter lg:backdrop-blur-sm lg:bg-opacity-50 px-10 lg:px-16 py-4 fixed top-0 left-0 w-full z-10">
      <nav className="text-white flex items-center gap-4 h-full relative">
        <div className="w-[20%] logo ">
          <Link to="/" onClick={handleClick}>
            <img className="w-[50px]" src={Logo} alt="" />
          </Link>
        </div>

        <div className="flex-1 hidden lg:block">
          <div className="Links flex gap-20 justify-center items-center text-[20px] pt-2 font-bold">
            <Link
              to="/about"
              className={`${splitLocation[1] === "about" ? "text-primary" : ""
                } hover:text-primary transition ease-in `}
            >
              <h6>ABOUT</h6>
            </Link>

            <Link
              to="/showcase"
              className={`${splitLocation[1] === "showcase" ? "text-primary" : ""
                } hover:text-primary transition ease-in `}
            >
              <h6>SHOWCASE</h6>
            </Link>
            {/* <Link
              to="/contact"
              className={`${
                splitLocation[1] === "contact" ? "text-primary" : ""
              } hover:text-primary transition ease-in `}
            >
              <h6>CONTACT</h6>
            </Link> */}
          </div>
        </div>

        <div className="w-[20%]  items-center  text-[28px] flex-end gap-10 justify-center hidden lg:flex text-primary">
          <Link
            to="http://instagram.com/temmiedesigns"
            className="text-white hover:bg-primary p-2 rounded-full transition ease-in "
          >
            <AiFillInstagram size="1.5rem" />
          </Link>

          <Link
            to="http://twitter.com/temmiedesigns"
            className="text-white hover:bg-primary p-2 rounded-full transition ease-in "
          >
            <AiFillTwitterCircle size="1.5rem" />
          </Link>
        </div>

        {/* handle mobile toggling */}
        <div className=" ml-auto self-center">
          <button onClick={() => setActive(!active)} className="flex lg:hidden">
            {active ? (
              <i class="fa-solid fa-xmark text-[24px]"></i>
            ) : (
              <i class="fa-solid fa-bars text-[24px]"></i>
            )}
          </button>
        </div>
        {/* handle mobile toggling End */}
      </nav>

      {/* mobile Menu */}
      {active && <MobileMenu handleClick={handleClick} />}
    </header>
  );
};

export default Header;
